import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";
import { getLoadsUrl, getMainUrl } from "../../utils/urls";
import styles from "./FindButtonsPanel.scss";

/** @param {RouteRequestPoint} from
 * @param {RouteRequestPoint} to
 */
const createLoadsLink = (from, to) => {
  const city = 2;
  const searchOptions = {
    exactFromGeos: true,
    exactToGeos: true,
    fromGeo: `${city}_${from.getCityId()}`,
    toGeo: `${city}_${to.getCityId()}`,
  };

  const jsonOptions = encodeURIComponent(JSON.stringify(searchOptions));
  return getLoadsUrl(`/#?filter=${jsonOptions}`);
};

/** @param {RouteRequestPoint} from
 * @param {RouteRequestPoint} to
 */
const createTrucksLink = (from, to) => {
  const city = 2;
  const fromGeo = `${city}_${from.getCityId()}`;
  const toGeo = `${city}_${to.getCityId()}`;

  return getMainUrl(`/Tables/Default.aspx?EntityType=Truck&FromGeo=${fromGeo}&ToGeo=${toGeo}`);
};

const FindButtonsPanel = ({ from, to, className, t }) => (
  <div className={classnames(styles.findButtonsSection, className)}>
    <div className={styles.services}>
      <a className={styles.loads} target="_blank" rel="noopener noreferrer" href={createLoadsLink(from, to)}>
        <div className={styles.badge}>
          <div className={styles.icon} />
          <div className={styles.text}>{t("trace-related-services-loads-find", "Найти")}</div>
        </div>
        <div className={styles.link}>
          <div className={styles.link}>{t("trace-related-services-loads-passing-loads", "попутные грузы")}</div>
        </div>
      </a>
      <a className={styles.trucks} target="_blank" rel="noopener noreferrer" href={createTrucksLink(from, to)}>
        <div className={styles.badge}>
          <div className={styles.icon} />
          <div className={styles.text}>{t("trace-related-services-trucks-find", "Найти")}</div>
        </div>
        <div className={styles.link}>
          <div className={styles.link}>{t("trace-related-services-trucks-passing-trucks", "попутные машины")}</div>
        </div>
      </a>
    </div>
  </div>
);

FindButtonsPanel.defaultProps = {
  className: "",
};

FindButtonsPanel.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withNamespaces()(FindButtonsPanel);
